import { render, staticRenderFns } from "./MsupplierCreate.vue?vue&type=template&id=65edac05"
import script from "./MsupplierCreate.vue?vue&type=script&lang=js"
export * from "./MsupplierCreate.vue?vue&type=script&lang=js"
import style0 from "./MsupplierCreate.vue?vue&type=style&index=0&id=65edac05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports